import { Table, Checkbox, Drawer, Button, Tooltip, Modal, Form, Input, Select, message,Tag,Collapse } from 'antd';
import { useState } from 'react';
import { LinkedinFilled,PhoneOutlined } from '@ant-design/icons';
import { CopyOutlined } from '@ant-design/icons';
import { encryptData, decryptData } from '../middleware/encryption';

const role = sessionStorage.getItem('role');
const { Option } = Select;

const { Panel } = Collapse;

const getColumns = (selectedFields, selectedKeys, handleSelect, handleSelectAll, handleNameClick, handleReveal, revealedContacts, showEditModal, showRevealModal,allSelectOptionAllowed) => {
  console.log(allSelectOptionAllowed);
  const columns = [
    {
      title: <Checkbox disabled={!allSelectOptionAllowed} checked={selectedKeys.length!=0} onChange={handleSelectAll} />,
      key: 'select',
      fixed: 'left',
      width: 50,
      render: (_, record) => <Checkbox checked={selectedKeys.includes(record.id)} onChange={() => handleSelect(record.id)} />,
    },
  ];

  selectedFields.forEach(field => {
    columns.push({
      title: field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
      dataIndex: field,
      fixed: field === 'company_name' ? 'left' : null,
      key: field,
      ellipsis: true,
      width: field === 'company_name' ? 200 : 150,
      sorter: (a, b) => {
        if (typeof a[field] === "number") {
          return a[field] - b[field]; // Numeric sorting
        } else if (typeof a[field] === "string") {
          return a[field].localeCompare(b[field]); // String sorting
        }
        return 0;
      },
      render: (text, record) => {
        if (field === 'company_name') {
          return (
            <Tooltip title={text}>
              <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', }}>
                <a className='color-table-text' style={{ textOverflow: 'ellipsis',width:"100"}} onClick={() => handleNameClick(record)}>{text}</a>
                {record.company_linkedin_url && (
                  <Tooltip title="Open LinkedIn">
                    <a className='color-table-text-active' href={record.company_linkedin_url} target="_blank" rel="noopener noreferrer" style={{ marginLeft: 8 }}>
                      <LinkedinFilled style={{ fontSize: '14px' }} />
                    </a>
                  </Tooltip>
                )}
              </div>
            </Tooltip>
          );
        }
        
        if (role === 'user') {
          const isRevealed = revealedContacts[record.id]?.[field] || record.isMobile;
          
          // Handle email or company_phone
          if (field === 'email') {
            if (!text) return '';
        
            return (
              <Tooltip title={isRevealed ? text : 'Click to reveal'}>
                <span
                  className="color-table-text-active"
                  onClick={() => handleReveal(record.id, field, text)}
                  style={{
                    cursor: 'pointer',
                    color: isRevealed ? 'inherit' : '#1890ff',
                    textDecoration: isRevealed ? 'none' : 'underline',
                  }}
                >
                  {isRevealed ? text : '+XX-XXXX-XXXX'}
                </span>
              </Tooltip>
            );
          }
        
          // Handle mobile_phone
          if (field === 'company_phone') {
            return (
              <button
                onClick={() => showRevealModal(record)}
                className="color-table-text-active"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  cursor: 'pointer',
                  color: isRevealed ? 'inherit' : '#1890ff',
                  textDecoration: isRevealed ? 'none' : 'underline',
                }}
              >
                <PhoneOutlined />
                Click to reveal
              </button>
            );
          }
        }

        if (field === 'company_phone' && role === 'admin') {
          return (
            <Tooltip title={text}>
              <span className='color-table-text-active'
                onClick={() => showRevealModal(record)}
                style={{ cursor: 'pointer',  textDecoration: 'underline' }}
              >
                {text || ''}
              </span>
            </Tooltip>
          );
        }

        return (
          <Tooltip title={text}>
            <div className='color-table-text' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 300 }}>{text}</div>
          </Tooltip>
        );
      },
    });
  });

  if (role === 'admin') {
    columns.push({
      title: 'Action',
      key: 'action',
      fixed: 'right',
      render: (_, record) => (
        <Button type="link" onClick={() => showEditModal(record)}>
          Edit
        </Button>
      ),
    });
  }

  return columns;
};

export default function CompanyTable({ data, selectedKeys, handleSelect, handleSelectAll, loading, selectedFields, fetchData ,getRemainingCredit,allSelectOptionAllowed}) {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [revealedContacts, setRevealedContacts] = useState({});
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isRevealModalVisible, setIsRevealModalVisible] = useState(false);
  const [form] = Form.useForm();

  const handleNameClick = (record) => {
    setSelectedCompany(record);
    setDrawerVisible(true);
  };

  const handleDrawerClose = () => {
    setDrawerVisible(false);
    setSelectedCompany(null);
  };

  const handleReveal = async (id, field, originalValue) => {
    if (revealedContacts[id]?.[field]) return;

    setSelectedCompany(data.find(company => company.id === id));

    const token = sessionStorage.getItem('access_token');
    const credit_deduct = field === 'email' ? 1 : 1;

    try {
      const response = await fetch("https://api.app.exellius.com/api/leads/deductCreditsFromUser", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + token,
        },
        body: JSON.stringify({ count: credit_deduct }),
      });

      const result = await response.json();

      if (response.ok) {
        setRevealedContacts(prev => ({
          ...prev,
          [id]: { ...prev[id], [field]: originalValue },
        }));
        if (field === 'company_phone') {
          setIsRevealModalVisible(true);
        }

        getRemainingCredit();
      } else {
         message.warning("You do not have enough credits");
        console.error("Credit deduction failed:", result);
       
      }
    } catch (error) {
      console.error("Error revealing contact:", error);
     
    }
  };

  const showEditModal = (record) => {
    setSelectedCompany(record);
    form.setFieldsValue(record);
    setIsEditModalVisible(true);
  };

  const handleEditCancel = () => {
    setIsEditModalVisible(false);
    setSelectedCompany(null);
  };

  const handleEditOk = async () => {
    try {
      const values = await form.validateFields();
      const token = sessionStorage.getItem('access_token');
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${token}`);

      const encryptedData = encryptData({  ...values, id: selectedCompany.id });

      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: JSON.stringify({ data: encryptedData }),
        redirect: "follow"
      };

      const response = await fetch("https://api.app.exellius.com/api/leads/editCompanyLeadData", requestOptions);
      const result = await response.json();

      if (response.ok) {
        const decryptedResponse = decryptData(result.data);
        message.success("Company updated successfully");
        setIsEditModalVisible(false);
        setSelectedCompany(null);
        fetchData(); // Refresh data after update
      } else {
        message.error(result.message || "Failed to update company");
      }
    } catch (error) {
      console.error("Error updating company:", error);
      message.error("An error occurred while updating the company");
    }
  };

  const showRevealModal = (record) => {
    setSelectedCompany(record);
    setIsRevealModalVisible(true);
  };

  return (
    <>
      <Table
        columns={getColumns(selectedFields, selectedKeys, handleSelect, handleSelectAll, handleNameClick, handleReveal, revealedContacts, showEditModal, showRevealModal,allSelectOptionAllowed)}
        dataSource={data}
        rowKey="id"
        loading={loading}
        pagination={false}
        scroll={{ x: 'max-content', y: 'calc(125vh - 312px)' }}
        bordered
      />
      <Drawer
        title="Company Details"
        placement="right"
        onClose={handleDrawerClose}
        visible={drawerVisible}
        width={600}
      >
      {selectedCompany && (
  <div>
    <Collapse defaultActiveKey={['1']}>
      <Panel header="Company Information" key="1">
        <p>
          <strong>Company Name:</strong><br />
          <Tag color={selectedCompany.company_name ? undefined : "red"}>
            {selectedCompany.company_name || "Not Found"}
          </Tag>
          {selectedCompany.company_linkedin_url && (
            <a href={selectedCompany.company_linkedin_url} target="_blank" rel="noopener noreferrer">
              <LinkedinFilled style={{ fontSize: '14px', marginLeft: 8 }} />
            </a>
          )}
        </p>
        <p>
          <strong>Industry:</strong><br />
          <Tag color={selectedCompany.industry ? undefined : "red"}>
            {selectedCompany.industry || "Not Found"}
          </Tag>
        </p>
        <p>
          <strong>Location:</strong><br />
          <Tag color={selectedCompany.company_address ? undefined : "red"}>
            {selectedCompany.company_address || "Not Found"}
          </Tag>
        </p>
        <p>
          <strong>Number of Employees:</strong><br />
          <Tag color={selectedCompany.num_employees ? undefined : "red"}>
            {selectedCompany.num_employees || "Not Found"}
          </Tag>
        </p>
        <p>
          <strong>Website:</strong><br />
          {selectedCompany.website ? (
            <a href={selectedCompany.website} target="_blank" rel="noopener noreferrer">
              <Tag>{selectedCompany.website}</Tag>
            </a>
          ) : (
            <Tag color="red">Not Found</Tag>
          )}
        </p>
        <p>
          <strong>Technologies:</strong><br />
          {selectedCompany.technologies ? (
            selectedCompany.technologies.split(',').map((tech, index) => (
              <Tag key={index}>{tech.trim()}</Tag>
            ))
          ) : (
            <Tag color="red">Not Found</Tag>
          )}
        </p>
        <p>
          <strong>SEO Description:</strong><br />
          <Tag color={selectedCompany.seo_description ? undefined : "red"} style={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: '100%' }}>
            {selectedCompany.seo_description || "Not Found"}
          </Tag>
        </p>
      </Panel>
    </Collapse>
  </div>
)}


      </Drawer>
      <Modal
        title="Edit Company"
        visible={isEditModalVisible}
        onOk={handleEditOk}
        onCancel={handleEditCancel}
        okText="Save"
      >
         <div className='modal-edit-container'>
        <Form form={form} layout="vertical">
          <Form.Item name="company_name" label="Company Name" rules={[{ required: true, message: 'Please input the company name!' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="num_employees" label="Number of Employees" rules={[{ required: true, message: 'Please input the number of employees!' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="industry" label="Industry" rules={[{ required: true, message: 'Please input the industry!' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="website" label="Website" rules={[{ required: true, message: 'Please input the website!' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="company_linkedin_url" label="Company LinkedIn URL">
            <Input />
          </Form.Item>
          <Form.Item name="facebook_url" label="Facebook URL">
            <Input />
          </Form.Item>
          <Form.Item name="twitter_url" label="Twitter URL">
            <Input />
          </Form.Item>
          <Form.Item name="company_street" label="Company Street">
            <Input />
          </Form.Item>
          <Form.Item name="company_city" label="Company City" rules={[{ required: true, message: 'Please input the company city!' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="company_state" label="Company State" rules={[{ required: true, message: 'Please input the company state!' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="company_country" label="Company Country" rules={[{ required: true, message: 'Please input the company country!' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="company_postal_code" label="Company Postal Code">
            <Input />
          </Form.Item>
          <Form.Item name="company_address" label="Company Address">
            <Input />
          </Form.Item>
          <Form.Item name="keywords" label="Keywords">
            <Input />
          </Form.Item>
          <Form.Item name="company_phone" label="Company Phone">
            <Input />
          </Form.Item>
          <Form.Item name="seo_description" label="SEO Description">
            <Input />
          </Form.Item>
          <Form.Item name="technologies" label="Technologies">
            <Input />
          </Form.Item>
          <Form.Item name="total_funding" label="Total Funding">
            <Input />
          </Form.Item>
          <Form.Item name="latest_funding" label="Latest Funding">
            <Input />
          </Form.Item>
          <Form.Item name="latest_funding_amount" label="Latest Funding Amount">
            <Input />
          </Form.Item>
          <Form.Item name="last_raised_at" label="Last Raised At">
            <Input />
          </Form.Item>
          <Form.Item name="annual_revenue" label="Annual Revenue">
            <Input />
          </Form.Item>
          <Form.Item name="num_retail_locations" label="Number of Retail Locations">
            <Input />
          </Form.Item>
          <Form.Item name="sic_codes" label="SIC Codes">
            <Input />
          </Form.Item>
          <Form.Item name="short_description" label="Short Description">
            <Input />
          </Form.Item>
          <Form.Item name="founded_year" label="Founded Year">
            <Input />
          </Form.Item>
        </Form>
        </div>
      </Modal>
      <Modal
  title="Contact numbers details"
  visible={isRevealModalVisible}
  onCancel={() => setIsRevealModalVisible(false)}
  footer={[
    <Button key="close" type="primary" onClick={() => setIsRevealModalVisible(false)}>
      Close
    </Button>
  ]}
>
  {selectedCompany && (
    <div style={{ marginTop: 20 }}>
      {/* Company Phone Reveal */}
      <p>
        <strong>Company Phone:</strong><br />
        {revealedContacts[selectedCompany.id]?.company_phone ? (
          <Tag color="blue">
            {selectedCompany.company_phone || <span style={{ color: 'red' }}>Not Found</span>}
            {selectedCompany.company_phone && (
              <Button
                icon={<CopyOutlined />}
                size="small"
                style={{ marginLeft: 8 }}
                onClick={() => {
                  navigator.clipboard.writeText(selectedCompany.company_phone);
                  message.success('Company phone copied');
                }}
              />
            )}
          </Tag>
        ) : (
          <Tag
            color="blue"
            onClick={() => handleReveal(selectedCompany.id, 'company_phone', selectedCompany.company_phone)}
            style={{ cursor: 'pointer' }}
          >
            +XX-XXXX-XXXX
          </Tag>
        )}
      </p>
    </div>
  )}
</Modal>

    </>
  );
}
